import DownChevronSVG from "../../../assets/icons/down-chevron.svg"
export const DownChevronIcon: React.FC = () => {
  return (
    <img src={DownChevronSVG} alt="" className="w-[12px] h-[8px] cursor-pointer"  />
  )
}
